/**
 * API configuration with automatic fallback to current origin
 * This ensures the app works even if REACT_APP_BACKEND_URL isn't set correctly
 */
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;
